import React from 'react'
import { PageSwoosh } from '../../lib/types'
import { withPublicAssetUrl } from '../../lib/utils/cdn'
import styles from './swoosh.module.scss'
import bts25SwooshStyles from './bts-25-swoosh.module.scss'

const ukraineSwooshBg = `url(${withPublicAssetUrl('swooshes/ukraine_colors.png')})`

const waveSwooshBg = `url(${withPublicAssetUrl('swooshes/wave.png')})`

const ribbonSwooshBg = `url(${withPublicAssetUrl('swooshes/ribbon.png')})`

const butterflySwooshBg = `url(${withPublicAssetUrl('swooshes/butterfly.png')})`

const peachSwooshBg = `url(${withPublicAssetUrl('swooshes/peach.png')})`

const eggSwooshBg = `url(${withPublicAssetUrl('swooshes/egg.png')})`

const grammarlyGOSwooshBg = `url(${withPublicAssetUrl('swooshes/grammarlygo.png')})`

const grammarlyGODiamondSwooshBg = `url(${withPublicAssetUrl('swooshes/grammarlygodiamond.png')})`

const ropeSwooshBg = `url(${withPublicAssetUrl('swooshes/rope.png')})`

const gridSwooshBg = `url(${withPublicAssetUrl('swooshes/grid.png')})`

export const getSwooshStyle = (
  swoosh?: PageSwoosh
): { className?: string; backgroundImage?: string; cloudElements?: React.ReactNode } => {
  if (!swoosh) {
    return {}
  }

  switch (swoosh) {
    case PageSwoosh.Ukraine:
      return { className: styles.rightTopSwoosh, backgroundImage: ukraineSwooshBg }
    case PageSwoosh.Wave:
      return { className: styles.bottomAlignedSwoosh, backgroundImage: waveSwooshBg }
    case PageSwoosh.Ribbon:
      return { className: styles.centerAlignedSwoosh, backgroundImage: ribbonSwooshBg }
    case PageSwoosh.Butterfly:
      return { className: styles.defaultSwoosh, backgroundImage: butterflySwooshBg }
    case PageSwoosh.Peach:
      return { className: styles.defaultSwoosh, backgroundImage: peachSwooshBg }
    case PageSwoosh.GrammarlyGO:
      return { className: styles.bottomAlignedTallSectionSwoosh, backgroundImage: grammarlyGOSwooshBg }
    case PageSwoosh.GrammarlyGODiamond:
      return {
        className: styles.bottomAlignedGrammarlyGoDiamondSectionSwoosh,
        backgroundImage: grammarlyGODiamondSwooshBg,
      }
    case PageSwoosh.Rope:
      return { className: styles.topAlignedRopeSwoosh, backgroundImage: ropeSwooshBg }
    case PageSwoosh.Grid:
      return { className: styles.topAlignedGridSwoosh, backgroundImage: gridSwooshBg }
    case PageSwoosh.Clouds:
      return {
        className: bts25SwooshStyles.cloudBackground,
        cloudElements: (
          <>
            <div className={bts25SwooshStyles.cloud2} />
            <div className={bts25SwooshStyles.cloud3} />
            <div className={bts25SwooshStyles.cloud4} />
            <div className={bts25SwooshStyles.cloud5} />
            <div className={bts25SwooshStyles.cloud6} />
            <div className={bts25SwooshStyles.cloud7} />
            <div className={bts25SwooshStyles.cloudBottomCover} />
            <div className={bts25SwooshStyles.cloudBottomCover2} />
            <div className={bts25SwooshStyles.horizonHaze} />
          </>
        ),
      }
    default:
    case PageSwoosh.Egg:
      return { className: styles.defaultSwoosh, backgroundImage: eggSwooshBg }
  }
}
